import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UnlinkedTransferAccountsPage, { getDefaultUI } from "components/pages/UnlinkedTransferAccountsPage";
import Classes from "model";

/**
 * @name CaptureAddTransferAccountMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureAddTransferAccountMain(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "addUnlinkedTransferAccountModal" ], { isActive: true, step: 1 })
    .submit();

    return <UnlinkedTransferAccountsPage ui={ ui } />;
}